import { render, staticRenderFns } from "./student.vue?vue&type=template&id=006efbbb&"
import script from "./student.vue?vue&type=script&lang=ts&"
export * from "./student.vue?vue&type=script&lang=ts&"
import style0 from "./student.vue?vue&type=style&index=0&id=006efbbb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports